import { Background, Props } from "./Background";

export default Background;

export {
    Background,
    Props,
};
